import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { WellpassBenefitListItemExtension } from './wellpass-benefit-list-item.extension';
import { WellpassBenefitMetadataExtension } from './wellpass-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('wellpass')
    .add(BenefitMetadataExtensionInterface, new WellpassBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new WellpassBenefitListItemExtension())
    .build(),
);
